import React from 'react';
import Quotation from '../qoute';

const Contact = () => {
  return (
    <div >
      <Quotation />
    </div>
  );
};

export default Contact;